import { types } from "../types";
import { has } from "lodash";

export interface IUiBlockerState {
  enabled?: boolean;
}

export const defaultState = {
  enabled: false
};

export const uiBlocker = (state = defaultState, action) => {
  if (action.type === types.SET_STATE && has(action.value, "uiBlocker")) {
    return action.value.uiBlocker;
  } else {
    return state;
  }
};
